import { eventBusAdapter } from "@/infrastructure/adapters/events/EventBus.adapter";
import { IAllEventsMap } from "@/core/events/allEventsMap";

interface EmitOptions {
    timeout?: number;
    onTimeout?: (event: string, handlerIndex: number) => void;
    onReject?: (event: string, handlerIndex: number, reason: string) => void;
    onNoSubscribers?: (event: string) => void;
}

export function useEventBusEmitter<K extends keyof IAllEventsMap>() {
    return {
        emit: async (event: K, payload: IAllEventsMap[K], options?: EmitOptions) => {
            await eventBusAdapter.emit<K>(event, payload, options);
        },
        getSubscriberCount: (event: K): number => eventBusAdapter.getSubscriberCount<K>(event),
    };
}
